import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { headersInstance } from '../../../../common/utils/HeaderUtils';
import { ICreateException } from '../../../models/index';
import { createNewException } from '../../actions/actionType/services/ServiceActionTypes';
import {
  cleargetCreateNewException,
  getCreateNewExceptionFailure,
  getCreateNewExceptionStart,
  getCreateNewExceptionSuccessful
} from '../../actions/sagaActions/exceptions/CreateNewExceptionSagaAction';
import {
  GetCreateNewExceptionFailurePayload,
  GetCreateNewExceptionRequest
} from '../../actions/types/exceptions/CreateNewExceptionTypes';

/**
 * Call Get metric summary by API
 * @returns api response
 */

export async function callGetCreateNewExceptionApi(data: ICreateException) {
  return apiWrapper.post(
    `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/exceptions`,
    data,
    headersInstance()
  );
}

export function* getCreateNewExceptionApi({ requestObject }: GetCreateNewExceptionRequest) {
  yield put(cleargetCreateNewException());
  yield put(getCreateNewExceptionStart());
  try {
    const { responseBody: data, isError, error } = yield call(callGetCreateNewExceptionApi, requestObject);
    if (isError) {
      throw error;
    }
    // put length check here
    if (data) {
      yield put(getCreateNewExceptionSuccessful(data));
    } else {
      throw new Error('No Response');
    }
  } catch (error: unknown) {
    const obj: GetCreateNewExceptionFailurePayload = {
      statusCode: 404,
      error: 'Unable to create new exception',
    };
    yield put(getCreateNewExceptionFailure(obj));
  }
}

/**
 * Saga Effect to consider latest request
 */
export function* GetCreateNewExceptionSaga() {
  yield takeLatest(createNewException.CREATE_NEW_EXCEPTION_REQUEST, getCreateNewExceptionApi);
}

export const getCreateNewExceptionSaga = [fork(GetCreateNewExceptionSaga)];
